import React, { Component } from 'react';

import {
    Link, Redirect
} from 'react-router-dom'
import * as XLSX from 'xlsx';

import {Transaction,TransactionTable} from '../../components/Transactions';
import {EmptyList} from '../../components/EmptyList';
import {Reloading} from '../../components/Loader';
import { CustomDateInput } from '../../components/CustomInput';

import {formatMoney} from '../../utils/common';
import {connect} from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css"
import { loadTran, loadTranWithouPagination } from '../../actions/Report';
import { Pagination } from '../../components/Pagination';
import { refreshToken } from '../../actions/RefreshToken';
const pageSize = 10;

class History extends Component {
    constructor(props){
        super(props);
        this.state = {
            from: moment("06:30","HH:mm").toDate(),
            to: moment("22:00","HH:mm").toDate(),
            page: 1,
            clickBtn: '',
            status: 0,
        }
    }

    componentDidMount(){
        this.handleGetTransactionList();
    }

    handleGetTransactionList = (newToken) => {
        let { appId, branchId, storeId, cashierId } = this.props;
        let { from, to, status } = this.state;

        let fromParam = moment(from).format("DD/MM/YYYY HH:mm");
        let toParam = moment(to).format("DD/MM/YYYY HH:mm");

        let checkToken = {}
        if (typeof newToken?.token === 'string' && typeof newToken?.refresh_token === 'string') {
            checkToken.access_token = newToken.token 
            checkToken.refresh_token = newToken.refresh_token 
        } else {
            checkToken.access_token = this.props.token
            checkToken.refresh_token = this.props.data.refresh_token
        }

        this.setState({
            clickBtn: 'get-list-trans'
        })

        this.props.dispatch(loadTran(appId,branchId,storeId,cashierId,fromParam,toParam, checkToken, this.state.page_size, this.state.page, status));
    }

    getListTransactionsClickApply = () => {
        this.setState({
			page: 1,
		}, () => {
            this.handleGetTransactionList()
		})
    }

    removeField(data, fieldToRemove) {
        return data.map(item => {
          const { [fieldToRemove]: removedField, ...rest } = item;
          return rest;
        });
      }

    handleExportXlsx = async (newToken) => {
        let { appId, branchId, storeId, cashierId } = this.props;
        let { from,to, status } = this.state;

        let fromParam = moment(from).format("DD/MM/YYYY HH:mm");
        let toParam = moment(to).format("DD/MM/YYYY HH:mm");

        let checkToken = {}
        if (typeof newToken?.token === 'string' && typeof newToken?.refresh_token === 'string') {
            checkToken.access_token = newToken.token 
            checkToken.refresh_token = newToken.refresh_token 
        } else {
            checkToken.access_token = this.props.token
            checkToken.refresh_token = this.props.data.refresh_token
        }

        this.setState({
            clickBtn: 'export-CSV'
        })

        const res = await loadTranWithouPagination(appId,branchId,storeId,cashierId,fromParam,toParam, checkToken, status)
        if (res?.transaction && res?.transaction?.length){
          res?.transaction.forEach(element => {
            if (element.status === 1) return element.status = 'Thành công';
            if (element.status === 5) return element.status = 'Thất Bại';
            if (element.status === 3) return element.status = 'Chờ xử lý';
           });
          const data = this.removeField(res?.transaction, 'revert_time');
          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          // Translate name of first row
          XLSX.utils.sheet_add_aoa(worksheet, [["Thời gian"]], { origin: "A1" });
          XLSX.utils.sheet_add_aoa(worksheet, [["Số tiền"]], { origin: "B1" });
          XLSX.utils.sheet_add_aoa(worksheet, [["Mã GD Merchant"]], { origin: "C1" });
          XLSX.utils.sheet_add_aoa(worksheet, [["Mã GD ZaloPay"]], { origin: "D1" });
          XLSX.utils.sheet_add_aoa(worksheet, [["Trạng thái"]], { origin: "E1" });
          XLSX.utils.sheet_add_aoa(worksheet, [["Ghi chú"]], { origin: "F1" });

          XLSX.writeFile(workbook, "export.xlsx");
        } else if (res?.sub_return_code === 3021) {
            this.props.dispatch(refreshToken(checkToken))
        }
    }   

    handleFromChange = (date) => {
        this.setState({
            from: date
        });
    }

    handleToChange = (date) => {
        this.setState({
            to: date
        });
    }

    handleStatusChange = (event) => {
        this.setState({status: event.target.value});
    }

    filterDatePicker = (date) => {
        let dpTimestamp = date.getTime()/1000;
        let currTimestamp = moment().unix();
        let pastTwoMonths = moment().subtract(2,'months').unix();

        return (dpTimestamp <= currTimestamp && dpTimestamp >= pastTwoMonths);
    }

    changePage = (pageIndex) => {
		if(pageIndex === this.state.page) return;

		if(pageIndex < 1 || pageIndex > Math.ceil(this.props.totalTranAllStatus/pageSize)) return;

		this.setState({
			page: pageIndex,
		}, () => {
            this.handleGetTransactionList()
		})
	}

    componentWillReceiveProps(nextProps) {
        if ((nextProps.token !== this.props.token) && this.state.clickBtn === 'get-list-trans') {
            this.handleGetTransactionList(nextProps)
        }
        if ((nextProps.token !== this.props.token) && this.state.clickBtn === 'export-CSV') {
            this.handleExportXlsx(nextProps)
        }
    }

    render() {
        let {settingData, data, isLoading, totalTran, totalIncome, totalTranAllStatus, transactions} = this.props;
		if(!settingData.isValidated) return <Redirect to='/setting' />
        let appName = data.apps ? data.apps.find(app => app.id === this.props.appId).name : "" ;
        let {from,to} = this.state;
		let totalList = totalTranAllStatus && new Array(Math.ceil(totalTranAllStatus/pageSize)).fill(0);

        return (
            <React.Fragment>
                <div className="container-fluid mt-4">
                    <div className="text-center">
                        <div className="page-title small-sm">Nhật ký giao dịch</div>
                    </div>

                    <div className="left-icons">
                        <Link to="/home"><img src="/cashier/shop/static/assets/images/icon-back.svg" width="28" alt=""/></Link>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-6 mb-4">
                            <div className="media">
                                <img className="mr-3" src="/cashier/shop/static/assets/images/logo-mc-default.svg" width="72" alt=""/>
                                <div className="media-body">
                                    <div className="mc-name mb-1">{appName.toUpperCase()}</div>
                                    <div className="txtGray fs-s">
                                    {settingData.branchName}<br/>
                                    {settingData.storeName + " - " + settingData.cashierName}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row mt-1">
                                <div className="col-6 mb-4 text-center summary-col">
                                    <div className="fs-s">TỔNG TIỀN GD THÀNH CÔNG</div>
                                    <strong className="txtBlack fs-m">{formatMoney(totalIncome,0,"") + " VNĐ"}</strong>
                                </div>
                                <div className="col-6 mb-4 text-center">
                                    <div className="fs-s">TỔNG SỐ GD THÀNH CÔNG</div>
                                    <strong className="txtBlack fs-m">{totalTran ? totalTran : 0}</strong>
                                </div>
                            </div>      
                        </div>
                    </div>

                    <div className="mt-2 row" id="filters">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>TỪ NGÀY/GIỜ</label>
                                <div className="customSelect">
                                    <DatePicker
                                        calendarClassName="display-row"
                                        customInput={<CustomDateInput />}
                                        selected={from}
                                        onChange={this.handleFromChange}
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={30}
                                        dateFormat="dd/MM/yyyy - HH:mm"
                                        timeCaption="time"
                                        filterDate={this.filterDatePicker}
                                        popperPlacement="bottom-start"
                                        popperModifiers={{
                                            flip: {
                                                behavior: ["bottom"] // don't allow it to flip to be above
                                            },
                                        }}
                                    >
                                    </DatePicker>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>ĐẾN NGÀY/GIỜ</label>
                                <div className="customSelect">
                                    <DatePicker
                                        calendarClassName="display-row"
                                        customInput={<CustomDateInput />}
                                        selected={to}
                                        onChange={this.handleToChange}
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={30}
                                        dateFormat="dd/MM/yyyy - HH:mm"
                                        timeCaption="time"
                                        filterDate={this.filterDatePicker}
                                        popperPlacement="bottom-start"
                                        popperModifiers={{
                                            flip: {
                                                behavior: ["bottom"] // don't allow it to flip to be above
                                            },
                                        }}
                                    >
                                    </DatePicker>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>TRẠNG THÁI GIAO DỊCH</label>
                                <div className="customSelect">
                                    <select className="form-control" onChange={this.handleStatusChange} value={this.state.value}>
                                        <option value="0">Tất cả</option>
                                        <option value="1">Thành Công</option>
                                        <option value="5">Thất bại</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group mt-md-4 mt-sm-0 filter-btns">
                                <a href="javascript:;" onClick={this.getListTransactionsClickApply} className="minW-130 btn btn-main medium-btn mr-3">
                                    <img src="/cashier/shop/static/assets/images/icon-filter.svg" width="15" alt="" className="mr-2"/>
                                    ÁP DỤNG
                                </a>
                                <a href="javascript:;" onClick={this.handleExportXlsx} className="minW-130 btn btn-green medium-btn">
                                    <img src="/cashier/shop/static/assets/images/icon-print.svg" width="15" alt="" className="mr-2"/>
                                    XUẤT BIỂU MẪU
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
				{
                    isLoading ?
                        <Reloading />
                        :
                        totalTranAllStatus > 0 ?
                                <>
                                    <TransactionTable>
                                        {
                                            transactions?.map((value, id) =>
                                                <Transaction newOrder={false} value={value} key={value.merchantcode} />
                                            )
                                        }
                                    </TransactionTable>

                                    <Pagination 
                                        totalList={totalList}
                                        page={this.state.page}
                                        changePage={this.changePage}
								    />
                                </>
                            :
                            <EmptyList />
                }
            </React.Fragment>
        );
    }
}

const
	mapStateToProps = (state) => {
		return {
			branchId: state.settingData.branchId,
			storeId: state.settingData.storeId,
			cashierId: state.settingData.cashierId,
			appId: state.settingData.appId,
			settingData: state.settingData,
            data: state.loginData.result,
            token: state.loginData.token,
            refresh_token: state.loginData.refreshToken,
            transactions: state.loadTranData.transactions,
            totalTran: state.loadTranData.totalTran,
            totalTranAllStatus: state.loadTranData.totalTranAllStatus,
            totalIncome: state.loadTranData.totalIncome,
            isLoading: state.loadTranData.isLoading
		}
	};

export default connect(mapStateToProps)(History);
